import React, { Component } from 'react'
import { Modal, Select, Table } from 'antd'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import ajax from '../../utils/ajax';
import PropagateLoader from '../../common/SubmitingForm'
import functions from '../../utils/functions';
import Notification from '../../common/Notification'

const { Option } = Select;

class AddPhysician extends Component {

  state = {
    userId: functions.sessionGuard(),
    specialityList: false,
    hospitalList: false,
    specialistsList: false,
    speciality: "",
    hospital: "",
    firstName: "",
    lastName: "",
    workHours: "",
    email: "",
    telephone: "",
    load: ""
  }

  componentDidMount() {
    this.getHospitals();
    this.getSpecialities();

  }

  handleCancel = () => {
    const sent = this.props
    this.setState({ visible: false })
    sent.handleCancel(false)
  }

  firstName = (value) => {
    this.setState({ firstName: value.target.value })
  }
  lastName = (value) => {
    this.setState({ lastName: value.target.value })
  }
  email = (value) => {
    this.setState({ email: value.target.value })
  }
  telephone = (value) => {
    this.setState({ telephone: value.target.value })
  }

  workHours = (value) => {
    this.setState({ workHours: value.target.value })
  }


  hospital = (value) => {
    if (value != null) {
      this.setState({ hospital: value })
    } else {
      this.setState({ hospital: "" })
    }

  }

  speciality = (value) => {
    if (value != null) {
      this.setState({ speciality: value })
    } else {
      this.setState({ speciality: "" })
    }

  }

  getHospitals = async () => {

    const server_response = await ajax.listHospitals();
    const hosOptions = []

    if (server_response.status === "OK") {

      server_response.details.content.list.map((hospitals) =>
        hosOptions.push(<Option value={hospitals.hospital_id}>{hospitals.full_hospital_name}</Option>
        ),
      )

      this.setState({
        hospitalsList: hosOptions
      })

    } else {
      // this.setState({
      //     categoryList: "404"
      // })
    }

  }

  getSpecialities = async () => {
    const server_response = await ajax.listSpeciality();
    const speOptions = []

    if (server_response.status === "OK") {
      // console.log(server_response.details.content)
      server_response.details.content.map((speciality) =>
        speOptions.push(<Option value={speciality.speciality_id}>{speciality.speciality_name}</Option>
        ),
      )

      this.setState({
        specialistsList: speOptions
      })

    } else {
      // this.setState({
      //     categoryList: "404"
      // })
    }
  }

  onPressAddSpecialist = async (event) => {
    event.preventDefault()

    const { speciality, hospital, firstName, lastName, workHours, email, telephone } = this.state

    if (speciality.length > 0 &&
      hospital.length > 0 &&
      firstName.length > 0 &&
      lastName.length > 0 &&
      workHours.length > 0 &&
      email.length > 0 &&
      telephone.length > 0) {

      this.setState({
        type: '',
        info: '',
        load: <PropagateLoader />
      })

      const server_response = await ajax.createSpecialist(speciality, hospital, firstName, lastName, workHours, email, telephone, this.state.userId)

      if (server_response.status === "OK") {
        this.setState({
          type: 'alert alert-success',
          info: server_response.details.message,
          load: '',
        })
        window.location.reload()

      } else {

        this.setState({
          type: 'alert alert-danger',
          info: server_response.details.message,
          load: '',
        })

      }


    } else {
      this.setState({
        type: 'alert alert-danger',
        info: 'Please be advised to fill in all required fields - All fields are required',
        load: "",
      })
    }
  }

  render() {
    return (

      <Modal
        title={"ADD NEW PHYSICIAN"}
        centered
        bodyStyle={{ paddingBottom: '0px', paddingTop: '0px' }}
        visible={this.props.visible.visible}

        maskClosable={false}
        footer={[null]}
        maskTransitionName=""
        onCancel={this.handleCancel}
        width={700}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: false }}
      >

        <br />
        <div class="row">
          <div class="col-sm-12 mobile-inputs">

            {this.state.load}
            <Notification
              message={{
                type: this.state.type,
                info: this.state.info,
              }}
            />

            <br />

            <form method="post" onSubmit={this.onPressAddSpecialist}>
              <div class="form-group row">
                <div class="col-sm-6">
                  <input type="text" onChange={this.firstName} class="form-control form-txt-primary" placeholder="First Name" />
                </div>
                <div class="col-sm-6">
                  <input type="text" onChange={this.lastName} class="form-control form-txt-primary" placeholder="Last Name" />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-6">
                  <input type="text" onChange={this.email} class="form-control form-txt-primary" placeholder="E-Mail" />
                </div>
                <div class="col-sm-6">
                  <input type="text" onChange={this.telephone} class="form-control form-txt-primary" placeholder="Telephone" />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-6">
                  <Select
                    // mode="multiple"
                    name="hospitalServices"
                    style={{ width: '100%' }}
                    placeholder="Select Clinic - Hospital"
                    onChange={this.hospital}>
                    <option> Select Clinic - Hospital </option>
                    {this.state.hospitalsList}

                  </Select>
                </div>
                <div class="col-sm-6">
                  <Select
                    // mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select Speciality"
                    onChange={this.speciality}>
                    <option> Select Speciality </option>
                    {this.state.specialistsList}

                  </Select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-6">
                  <input type="text" onChange={this.workHours} class="form-control form-txt-primary" placeholder="Working Hours" />
                  {/* <Select
    mode="multiple"
    name="hospitalServices"
    style={{ width: '100%' }}
    placeholder="Select Services Offered"
    onChange={this.hospitalServices}>
    {this.state.serviceList}

</Select> */}
                </div>

              </div>
              <div class="row">
                <div class="col-sm-3" >
                  <button type="submit" class="btn btn-primary btn-block mb-3">Add Specialist</button>
                </div>
              </div>
            </form>
          </div>
        </div>


      </Modal>

    )
  }
}

export default AddPhysician